import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {

	//                保证金
	selectMargin({ commit }, params) {   //初始查询
		return new Promise((resolve, reject) => {
			axios.post('margin/selectMargin', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},


	getMargin({ commit }, params) { //查看
		return new Promise((resolve, reject) => {
			axios.get('margin/getMargin', { params })
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	insertMargin({ commit }, params) { //新建
		return new Promise((resolve, reject) => {
			axios.post('margin/insertMargin', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	saveMargin({ commit }, params) {   //编辑
		return new Promise((resolve, reject) => {
			axios.post('margin/saveMargin', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	approveStartDeposit({ commit }, params) {       //是否同意拒绝
		return new Promise((resolve, reject) => {
			axios.post('deposit/approveStartDeposit', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	getNodeInfomation({ commit }, params) {       //取type
		return new Promise((resolve, reject) => {
			axios.post('/workflowApproval/getNodeInfomationByWorkflowTreeId', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	getApproverAndCreater({ commit }, params) {       //判断是否为节点审批人
		return new Promise((resolve, reject) => {
			axios.post('/workflowApproval/getApproverAndCreater', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	customerId({ commit }, params) {       //查询客户信息
		return new Promise((resolve, reject) => {
			axios.get('/customer/customerId', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	
	findDetailByCustomerId({ commit }, params) {       //查询客户信息
		return new Promise((resolve, reject) => {
			axios.get('/customer/findDetailByCustomerId', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
  
  getStudentById({ commit }, params) {       //查询客户信息
		return new Promise((resolve, reject) => {
			axios.get('/student/getStudentById', {params}).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	getStudentByIdNew({ commit }, params) {       //查询客户信息
		return new Promise((resolve, reject) => {
			axios.post('/studentInfoNew/findById', params).then(response => {
				resolve(response)
			}).catch(error => {
				reject(error)
			})
		})
	},

	searchOrderHistory({ commit }, params) {       //获取流程信息
		return new Promise((resolve, reject) => {
			axios.post('/workflowApproval/searchOrderHistory', params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},
	findServiceRecordAll({ commit }, params) {       //获取服务信息
		return new Promise((resolve, reject) => {
			axios.post('/service/findServiceRecordAll', params) 
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
	},

	updateMarginStatus({ commit }, params) {       //删除
		return new Promise((resolve, reject) => {
			axios.get('/margin/updateMarginStatus', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  getRefundMargin({ commit }, params) {       //获取退款订单详情
		return new Promise((resolve, reject) => {
			axios.get('/margin/getRefundMargin', {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  
}
